import { getOutages } from '@/api/getOutages'
import Banner from '@/components/banner'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/outages')({
  component: RouteComponent,
})

function RouteComponent() {
  const [isLoading, data, error] = getOutages()
  const pageBuilder = data?.data?.page_builder ?? []

  const renderContent = () => {
    if (isLoading)
      return <p className="text-lg font-semibold py-5">Loading outages...</p>

    if (error)
      return (
        <div className="flex flex-col justify-center py-5">
          <p className="text-xl font-bold text-red-600">
            There was an error loading outage data.
          </p>
          <p className="text-base text-gray-600 mt-2">
            Please try again later.
          </p>
        </div>
      )

    if (pageBuilder.length === 0)
      return <p className="text-base text-gray-600">All Systems Online!</p>

    return pageBuilder.map((section: any, i: number) => (
      <div key={i} dangerouslySetInnerHTML={{ __html: section.content }} />
    ))
  }

  return (
    <>
      <Banner
        backgroundUrl="/img/legal.jpg"
        containerStyle=" min-h-[450px] lg:min-h-[550px]"
      />

      <div className="breakpoint-container px-0 md:px-4 -mt-[210px] z-10 mb-20">
        <h1 className="text-6xl text-white font-bold mb-15 px-4 md:px-0">
          Outages
        </h1>

        <div className="card">
          <p className="text-base">
            The status of our network and that of our wholesalers is shown
            below.
          </p>

          <div className="outage-content my-10">{renderContent()}</div>

          <p className="text-base mb-3">
            For further information on how we report major outages, please refer
            to our{' '}
            <a href="/pdf/communication-of-major-outages.pdf" target="_blank">
              Major Outage Communications Procedure
            </a>
            .
          </p>

          <p className="text-xl font-bold">Our Wholesalers</p>
          <p className="text-base mt-3">
            For information on outages affecting nbn®, please visit the link
            below:
          </p>
          <ul className="mt-3 ml-10 list-disc list-outside">
            <li className="text-base">
              <a
                href="https://www.nbnco.com.au/support/network-status"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbn® outages
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
